import React, { useState, useEffect } from "react"
import "./Sidebar.css"
import { Plus, Menu, Zap, RotateCcw, Settings, History } from "lucide-react"
import BlocksPanel from "./BlocksPanel"
import OutlinePanel from "./OutlinePanel"

const Sidebar = ({ onSelectBlock, nodes, edges, onNodeSelect, onOpenTriggersPanel, onOpenBlocksPanel, onOpenOutlinePanel, onOpenHistoryPanel, openPanel, showBlocksPanel, showTriggersPanel, showOutlinePanel, showHistoryPanel, setShowBlocksPanel, setShowTriggersPanel, setShowOutlinePanel, setShowHistoryPanel, workflowId, permissions, twilio, canSendTexts, canSendEmails }) => {
  const [activeTooltip, setActiveTooltip] = useState(null)

  const handleSelectBlock = (blockId) => {
    onSelectBlock(blockId)
    setShowBlocksPanel(false)
  }

  return (
    <>
      <div
        className="sidebar disable-flow-panning dark:bg-card dark:border-border"
        onMouseEnter={() => {
          // Add a class to the body to disable flow panning when hovering the sidebar
          document.body.classList.add("disable-flow-panning")
        }}
        onMouseLeave={() => {
          // Remove the class when leaving the sidebar
          document.body.classList.remove("disable-flow-panning")
        }}
        onClick={(e) => {
          // Prevent click events from propagating to the canvas
          e.stopPropagation()
        }}
      >
        <div className="sidebar-top">
          <div className="sidebar-button-container">
            <button
              className={`sidebar-button dark:hover:bg-[#0070f3] ${showBlocksPanel ? "active dark:hover:text-white" : "dark:text-white"}`}
              onClick={() => {
                onOpenBlocksPanel()
                setShowHistoryPanel(false)
              }}
              onMouseEnter={() => setActiveTooltip("blocks")}
              onMouseLeave={() => setActiveTooltip(null)}
            >
              <Plus size={20} />
            </button>
            {activeTooltip === "blocks" && <div className="sidebar-tooltip">Blocks</div>}
          </div>

          {/* <div className="sidebar-button-container">
            <button
              className={`sidebar-button ${showOutlinePanel ? "active" : ""}`}
              onClick={onOpenOutlinePanel}
              onMouseEnter={() => setActiveTooltip("outline")}
              onMouseLeave={() => setActiveTooltip(null)}
            >
              <Menu size={20} />
            </button>
            {activeTooltip === "outline" && <div className="sidebar-tooltip">Outline</div>}
          </div> */}

          <div className="sidebar-button-container">
            <button
              className={`sidebar-button dark:hover:bg-[#0070f3] ${showTriggersPanel ? "active dark:hover:text-white" : "dark:text-white"}`}
              onClick={() => {
                // Find the trigger node in the current workflow
                const triggerNode = nodes?.find(node => node.type === 'triggerNode')
                const triggerNodeId = triggerNode?.id || 'start-trigger'
                const enabledTriggers = triggerNode?.data?.enabledTriggers || []
                
                setShowTriggersPanel(true)
                setShowBlocksPanel(false)
                setShowOutlinePanel(false)
                setShowHistoryPanel(false)
                
                // Call the parent's handleOpenTriggersPanel with proper context
                if (onOpenTriggersPanel) {
                  onOpenTriggersPanel("triggers", workflowId, triggerNodeId, enabledTriggers)
                }
              }}
              onMouseEnter={() => setActiveTooltip("triggers")}
              onMouseLeave={() => setActiveTooltip(null)}
            >
              <Zap size={20} />
            </button>
            {activeTooltip === "triggers" && <div className="sidebar-tooltip">Triggers</div>}
          </div>

          {permissions?.can_view_workflow_history && (
            <div className="sidebar-button-container">
              <button
                className={`sidebar-button dark:hover:bg-[#0070f3] ${showHistoryPanel ? "active dark:hover:text-white" : "dark:text-white"}`}
                onClick={() => {
                  setShowHistoryPanel(true)
                  setShowBlocksPanel(false)
                  setShowOutlinePanel(false)
                  setShowTriggersPanel(false)
                  
                  // Call the parent's handleOpenHistoryPanel
                  if (onOpenHistoryPanel) {
                    onOpenHistoryPanel()
                  }
                }}
                onMouseEnter={() => setActiveTooltip("history")}
                onMouseLeave={() => setActiveTooltip(null)}
              >
                <History size={20} />
              </button>
              {activeTooltip === "history" && <div className="sidebar-tooltip">History</div>}
            </div>
          )}

          {/* <div className="sidebar-button-container">
            <button
              className="sidebar-button"
              onMouseEnter={() => setActiveTooltip("deployHistory")}
              onMouseLeave={() => setActiveTooltip(null)}
            >
              <RotateCcw size={20} />
            </button>
            {activeTooltip === "deployHistory" && <div className="sidebar-tooltip">Deploy History</div>}
          </div> */}

          {/* <div className="sidebar-button-container">
            <button
              className="sidebar-button"
              onMouseEnter={() => setActiveTooltip("settings")}
              onMouseLeave={() => setActiveTooltip(null)}
            >
              <Settings size={20} />
            </button>
            {activeTooltip === "settings" && <div className="sidebar-tooltip">Settings</div>}
          </div> */}
        </div>
      </div>
      {showBlocksPanel && (
        <BlocksPanel
          onClose={() => setShowBlocksPanel(false)}
          onSelectBlock={handleSelectBlock}
          twilio={twilio}
          canSendTexts={canSendTexts}
          canSendEmails={canSendEmails}
          className="disable-flow-panning"
        />
      )}

      {showOutlinePanel && (
        <OutlinePanel
          nodes={nodes || []}
          edges={edges || []}
          onClose={() => setShowOutlinePanel(false)}
          onNodeSelect={onNodeSelect}
          className="disable-flow-panning"
        />
      )}
    </>
  )
}

export default Sidebar
